import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow01",
  "use": "icon-arrow01-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow01\">\r\n<path d=\"M4.99996 18L7.49996 12.5L4.99996 7L19 12.5L4.99996 18Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol